import React, { useState } from "react";
import axios from "../utils/axios";
import { login } from "../utils/auth";
import { useHistory } from "react-router";
import { ToastContainer } from "react-toastr";
import logo from "../assets/logo.png";
import metadata from "../metadata.json";

export default function Login() {
  const history = useHistory();
  const [data, setData] = useState({
    code: "",
    password: "",
  });
  const [error, setError] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = await axios()
        .post("/token", data)
        .then(async ({ data }) => {
          return data.token;
        });
      const {
        name,
        department,
        empId,
        userCode,
        departmentId,
        empName,
        userId,
        userRole,
        empCode,
      } = await axios()
        .get(`/user`, {
          headers: {
            authorization: "jwt " + token,
            "content-type": "application/json",
          },
        })
        .then(({ data }) => {
          return {
            name: data.Employee.fullName,
            department: data.Employee.Department.name,
            departmentId: data.Employee.Department.id,
            empId: data.Employee.id,
            empCode: data.Employee.code,
            empName: data.Employee.fullName,
            userCode: data.code,
            userId: data.id,
            userRole: data.UserGroup.role,
          };
        });
      login(
        token,
        name,
        department,
        empId,
        userCode,
        departmentId,
        empName,
        userId,
        userRole,
        empCode
      );
      setTimeout(() => {
        history.push("/home");
      }, 500);
    } catch (err) {
      if (err.message.slice(32, 35) === "401") {
        container.error(`Incorret User ID or Password`, null, {
          timeOut: 1000,
        });
      }
      setError(true);
      console.log(err.message);
    }
  };

  const handleChange = (e) => {
    e.persist();
    setData((inputs) => ({
      ...inputs,
      [e.target.name]: e.target.value,
    }));
  };
  let container;

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: "100%" }}
    >
      <ToastContainer
        ref={(ref) => (container = ref)}
        className="toast-center"
      />
      <div className="login-box">
        <div className="login-logo">
          <img
            src={logo}
            alt="Kaskal Logo"
            className="brand-image mb-4"
            width="360"
            height="205"
          />
        </div>
        {/* /.login-logo */}
        <div className="card">
          <div className="card-body login-card-body">
            <p className="login-box-msg h3">
              <b>Timesheets</b>
            </p>
            <p className="login-box-msg">{`V. ${metadata.buildMajor}.${metadata.buildMinor}.${metadata.buildRevision} ${metadata.buildTag}`}</p>
            <form onSubmit={handleSubmit}>
              <div className="input-group mb-3">
                <input
                  type="text"
                  name="code"
                  onChange={handleChange}
                  className={error ? "form-control is-invalid" : "form-control"}
                  placeholder="User ID."
                  style={{
                    backgroundImage: 'url("data:image/png',
                    backgroundRepeat: "no-repeat",
                    backgroundAttachment: "scroll",
                    backgroundSize: "16px 18px",
                    backgroundPosition: "98% 50%",
                    cursor: "auto",
                  }}
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-id-card-alt" />
                  </div>
                </div>
              </div>
              <div className="input-group mb-3">
                <input
                  type="password"
                  className={error ? "form-control is-invalid" : "form-control"}
                  name="password"
                  onChange={handleChange}
                  placeholder="Password"
                  style={{
                    backgroundImage: 'url("data:image/png',
                    backgroundRepeat: "no-repeat",
                    backgroundAttachment: "scroll",
                    backgroundSize: "16px 18px",
                    backgroundPosition: "98% 50%",
                    cursor: "auto",
                  }}
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-lock" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <button type="submit" className="btn btn-primary btn-block">
                    Sign In
                  </button>
                </div>
                {/* /.col */}
              </div>
            </form>
          </div>
          {/* /.login-card-body */}
        </div>
      </div>
    </div>
  );
}
